import { Field, ID, InputType, registerEnumType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { Chat } from '../Chat'

export enum ChatDocumentKindEnum {
  Order = 'Order',
  PurchaseOrder = 'PurchaseOrder',
  Logistic = 'Logistic',
}

registerEnumType(ChatDocumentKindEnum, {
  name: 'ChatDocumentKindEnum',
  description: 'The kind of document a conversation can be attached to',
})

@InputType()
export class LinkChatToDocumentArgs extends ActionArgs {
  @Field(() => ID)
  chatId: string

  @Field(() => ChatDocumentKindEnum)
  documentKind: ChatDocumentKindEnum

  @Field(() => ID)
  documentId: string
}

export interface ILinkChatToDocument extends IAction<Chat, LinkChatToDocumentArgs> {}
